export const preloadImage = (url) => {
  const img = new Image()
  img.src = url
  return img
}